import { ChangeDetectionStrategy, Component } from '@angular/core';

// The Header Tests card's body on the Test UI Components page: a primary header, a secondary header
// with a back button, and a header with a dropdown arrow.
@Component({
  selector: 'cs-test-headers-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-headers-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestHeadersCardComponent {}
